import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header";

const getSubcompany = () => {
  return axios.get(API + "company/subcompanies/", { headers: authHeader() });
};

const createSubcompany = (data) => {
  return axios.post(API + "company/subcompanies/create/", data, {
    headers: authHeader(),
  });
};

const updateSubcompany = (id, data) => {
  return axios.put(API + `company/subcompanies/${id}/update/`, data, {
    headers: authHeader(),
  });
};

const deleteSubcompany = (id) => {
  return axios.delete(API + `company/subcompanies/${id}/delete/`, {
    headers: authHeader(),
  });
};

const subcompanyService = {
  getSubcompany,
  createSubcompany,
  updateSubcompany,
  deleteSubcompany,
};

export default subcompanyService;
